import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <>
      <SEOHead title="Terms & Conditions" description="Temple Israel of Brevard website terms and conditions." path="/terms" />
      <PageHero eyebrow="Terms" title="Terms & Conditions" subtitle="Effective: February 27, 2026" />
      <section className="bg-[var(--paper)] py-20 lg:py-28">
        <div className="max-w-3xl mx-auto px-5 lg:px-10 prose-tiob">
          <p>
            These Terms & Conditions ("Terms") govern your use of the Temple Israel of Brevard
            website (the "Site"). By using the Site, you agree to these Terms.
          </p>

          <h2>Use of the Site</h2>
          <p>
            The Site is provided for informational purposes and to facilitate communication, event
            registration, membership inquiry, and charitable giving. You agree to use the Site
            lawfully and respectfully.
          </p>

          <h2>Intellectual Property</h2>
          <p>
            All content on the Site - including text, images, logos, and design - is owned by
            Temple Israel of Brevard or used with permission. You may not reproduce, distribute,
            or create derivative works without our written consent, except for personal,
            non-commercial use.
          </p>

          <h2>Donations</h2>
          <p>
            All donations are voluntary and processed by Stripe. Temple Israel of Brevard is a
            501(c)(3) nonprofit; donations may be tax-deductible to the extent allowed by law.
            Receipts are emailed upon successful donation.
          </p>

          <h2>Third-Party Links</h2>
          <p>
            The Site may link to third-party websites. We are not responsible for the content,
            policies, or practices of those sites.
          </p>

          <h2>Disclaimer & Limitation of Liability</h2>
          <p>
            The Site is provided "as is" without warranties of any kind. TIOB is not liable for
            any indirect, incidental, or consequential damages arising from your use of the Site.
          </p>

          <h2>Accessibility</h2>
          <p>
            We are committed to providing an accessible website experience for all users and
            strive to follow recognized accessibility standards, including WCAG guidelines. We
            have implemented industry-standard accessibility tools and continue to review, update,
            and improve our website to enhance accessibility. Because accessibility is an ongoing
            process, some areas of the website may not yet fully conform to all accessibility
            standards. If you encounter accessibility barriers, please{" "}
            <Link to="/contact" className="text-[var(--cyan-deep)] underline">contact us</Link>{" "}
            so we can provide assistance, offer alternative access, and address the issue where
            feasible. Nothing in these Terms is intended to limit any rights available under
            applicable accessibility laws. See our full{" "}
            <Link to="/accessibility" className="text-[var(--cyan-deep)] underline">Accessibility Statement</Link>.
          </p>

          <h2>Changes</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Site constitutes
            acceptance of the updated Terms.
          </p>

          <h2>Contact</h2>
          <p>
            Email{" "}
            <a className="text-[var(--cyan-deep)] underline" href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a> with any questions about these Terms.
          </p>
        </div>
      </section>
    </>
  );
}
